import React, { Component } from 'react';
import { Request } from 'components/Request';
import EmptyMatchmakingTabComponent from '../elements/EmptyMatchmakingTabComponent';
import GeneralLargeBackButtonComponent from '../elements/GeneralLargeBackButtonComponent';
import LoaderFullPage from '../elements/LoaderFullPage';
import { __ } from 'i18n/index';

export default class ChatRulesComponent extends Component {
	constructor(props) {
		super(props);

		this.state = {
			rules: null,
			rulesError: false,
			loading: true,
		};
	}

	componentDidMount() {
		Request.apiv1Get('chat/general_rules')
			.then((response) => {
				this.setState({
					rules: response.html_content || null,
					loading: false,
				});
			})
			.catch((response) => {
				console.error(response);
				this.setState({
					rulesError: true,
					loading: false,
				});
			});
	}

	render() {
		const { toggleChatRules } = this.props;
		const { rules, loading, rulesError } = this.state;
		return (
			<div className='chat-rules-popout-holder'>
				<GeneralLargeBackButtonComponent
					onClick={toggleChatRules}
				/>
				{loading &&
				<LoaderFullPage
					text={__('Getting Them Rules')}
				/>
				}
				{!loading && (rulesError || !rules) &&
				<EmptyMatchmakingTabComponent>
					{rulesError ? __('Could not load rules.') : __('No rules have been set.')}
				</EmptyMatchmakingTabComponent>
				}
				{!loading && !rulesError && rules &&
				<div className='chat-rules-popout panel-body'>
					<div dangerouslySetInnerHTML={{ __html: rules }} />
				</div>
				}
			</div>
		);
	}
}